import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { RecommendDuoCandidatesResponse } from 'generated/openapi';

import {
  getRecommendedPlayersKey,
  getRecommendedPlayersOptions,
} from './getRecommendedPlayers.options';

export interface UseGetRecommendedPlayersProps<
  T = RecommendDuoCandidatesResponse['users'],
> {
  options?: Omit<
    UseQueryOptions<RecommendDuoCandidatesResponse['users'], unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetRecommendedPlayers<
  T = RecommendDuoCandidatesResponse['users'],
>(props: UseGetRecommendedPlayersProps<T> = {}) {
  const { options } = props;

  return useQuery({
    ...getRecommendedPlayersOptions<T>(),
    ...options,
  });
}

useGetRecommendedPlayers.getQueryKey = getRecommendedPlayersKey;
